module.exports = __webpack_public_path__ + "img/EmptyWorkQueueList.41cb0ea5.svg";